export default "__VITE_ASSET__XhPHlJJ___"